import { createApp} from "vue";
import App from "./top/App.vue";

createApp(App).mount("#js-app");
